/**
 * Fetch virtual page context for GAM/Xandr ad-slot creatives.
 */

import type { HeadingsExtractionResult } from './extractHeadings';

export type PageContextSource = 'cache' | 'index' | 'httpx' | 'firecrawl' | 'degraded';

export interface PageContextApiConfig {
  apiKey: string;
  apiBaseUrl: string;
  agentDisplayId?: string;
  publisherId?: string;
}

export interface PageContextResponse {
  context: HeadingsExtractionResult & { degraded?: boolean };
  source: PageContextSource;
  cache_hit: boolean;
}

export async function fetchPageContext(
  url: string,
  config: PageContextApiConfig,
): Promise<PageContextResponse> {
  const base = (config.apiBaseUrl || 'https://api.useadmesh.com').replace(/\/$/, '');
  const params = new URLSearchParams({ url: url.trim() });
  if (config.agentDisplayId?.trim()) {
    params.set('agent_display_id', config.agentDisplayId.trim());
  }
  if (config.publisherId?.trim()) {
    params.set('publisher_id', config.publisherId.trim());
  }

  const response = await fetch(`${base}/publisher-assistant/page-context?${params.toString()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${config.apiKey}`,
    },
  });

  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new Error(`Page context request failed (${response.status}): ${body || response.statusText}`);
  }

  return (await response.json()) as PageContextResponse;
}
